<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="40" height="40" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }"
        *ngIf="control.elementVal.getValue()?.txtId > 0">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }"
        *ngIf="!(control.elementVal.getValue()?.txtId > 0)">
        {{ control.elementVal.getValue()?.params.dayId | weekDay }}
    </h2>
    <div class="control__content control__arrows on-off">
        <img ngSrc="/assets/img/icons/arrows.svg"
             width="40" height="40" alt="" />
    </div>

    <div class="control__content">
        <div class="on-off color-basic"
            [ngClass]="{ 'on-off--single': schedule.onOffTable.length <= 25 }"
            id="scrollSet">
            <div class="on-off__wrapper">
                <div class="color-basic"></div>
                <div class="on-off__select-hour color-basic"
                     *ngFor="let val of schedule.onOffTable; let key = index"
                     [attr.data-testid]="'onOffHour-'+ key"
                     (pointerdown)="onPointerDown($event, val.val, key)"
                     (pointercancel)="onPointerCancel()"
                     (pointerup)="onPointerUp($event, key)">
                    <div class="on-off__select-hour-name color-basic font-10">
                        {{val.hour}}:00
                    </div>
                    <div class="on-off__select-hour-box"
                        [ngClass]="{ 'hide': key == 0 }">
                        <div class="on-off__select-hour-inside"
                            [attr.data-testid]="'onOffHourBox-'+ key"
                            [ngClass]="{ 'bg-style': val.val,
                            'bg-default': !val.val }">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="Array.isArray(control.brotherElement)">
            <div class="control__checkbox-weekday"
                *ngFor="let value of control.brotherElement.sort(sortById)">
                <label class="color-basic cursor-pointer">
                    <span class="control__checkbox-weekday-name"
                        [ngClass]="{ 'font-bold': value.id === control.elementVal.getValue()?.id }">
                        {{ value.params.dayId | weekDay }}
                    </span>
                    <input class="control__checkbox-weekday-input cursor-pointer"
                        type="checkbox"
                        [disabled]=" value.id === control.elementVal.getValue()?.id"
                        [(ngModel)]="value.checked" />
                </label>
            </div>
        </ng-container>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="schedule.onOffGetSet('default')">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="schedule.returnOnOffTable()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
